import React, { useState } from "react";
import Modal from "./Modal_Components/Modal";
import Tippy from "@tippyjs/react";
import { useLoading, Rings } from "@agney/react-loading";
import { useXarrow } from "react-xarrows";
import { delete_step } from "./Api";
import { useDrop } from "react-dnd";
import { useEffect } from "react";


export function Content() {
  const { containerProps, indicatorEl } = useLoading({
    loading: true,
    indicator: <Rings widSth="100" />,
  });

  return <section {...containerProps}>{indicatorEl}</section>;
}

const Drop_Trigger_Node = (props) => {
  const updateXarrow = useXarrow();

  // Triggers
  const [{ trigger_isOver }, trigger_drop] = useDrop({
    accept: "trigger_card",
    drop: (item, monitor) => {

      props.modal_props(true, false, "", null, null, null, item.name);
      updateXarrow();
    },
    collect: (monitor) => ({
      trigger_isOver: !!monitor.isOver(),
    }),
  });

  return (
    <a className="trigger_nodes" >
      <div className="card mb-3 kw_node_card_drop" id={props.id} ref={trigger_drop}>
        <div className="kw_node_card-header_drop">{props.name}</div>
        <div className="kw_node_card-body_drop">
          <div className="first-body-section_drop">

          </div>
        </div>

      </div>
    </a>
  );
};

export default Drop_Trigger_Node;
